var __TEMP__ = require('./_getMapData.js');var getMapData = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = mapCacheSet;
